export default __webpack_public_path__ + "static/media/SA_Templates_M3.36f4ecc2.pdf";